import { render, staticRenderFns } from "./HrHireRegistWeb.vue?vue&type=template&id=323c3a70&scoped=true&"
import script from "./HrHireRegistWeb.vue?vue&type=script&lang=js&"
export * from "./HrHireRegistWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c3a70",
  null
  
)

export default component.exports